/*
* Component to wrap search text input fields with debounce functionality
*/

import * as PropTypes from 'prop-types';
import * as React from 'react';
import { DebounceInput } from 'react-debounce-input';

export interface ISearchInputProps {
    className?: string;
    debounceTimeout?: number;
    forceNotifyByEnter?: boolean;
    forceNotifyOnBlur?: boolean;
    minLength?: number;
    onChange?: any;
    placeholder?: string;
    element?: string;
    value?: any;
}

export default class SearchInput extends React.Component<ISearchInputProps, any> {
    public static propTypes = {
        className: PropTypes.string,
        debounceTimeout: PropTypes.number,
        forceNotifyByEnter: PropTypes.bool,
        forceNotifyOnBlur: PropTypes.bool,
        minLength: PropTypes.number,
        onChange: PropTypes.func,
        placeholder: PropTypes.string,
        element: PropTypes.string,
        value: PropTypes.any,
    };

    public static defaultProps = {
        className: 'form-control',
        element: '',
        debounceTimeout: 500,
        forceNotifyByEnter: true,
        forceNotifyOnBlur: true,
        minLength: 2,
        placeholder: '',
    };

    public constructor(props: ISearchInputProps) {
        super(props);
    }

    public render() {
        const {
            className,
            debounceTimeout,
            forceNotifyByEnter,
            forceNotifyOnBlur,
            minLength,
            onChange,
            element,
            placeholder,
            value,
            ...rest
        } = this.props;

        let el = {};
        if (element) {
            el = { element: element };
        }

        return (
            <DebounceInput
                className={className}
                debounceTimeout={debounceTimeout}
                forceNotifyByEnter={forceNotifyByEnter}
                forceNotifyOnBlur={forceNotifyOnBlur}
                minLength={minLength}
                onChange={onChange}
                placeholder={placeholder}
                value={value}
                {...el}
                {...rest}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/common/searchInput.tsx